import React, { useState } from 'react';
import {
  CardContent,
  Collapse,
  Grid,
  Skeleton,
  Typography,
  Box,
  List,
  ListItem,
  Stack,
  // isTv,
  // useMediaQuery,
} from '@mui/material';
// import { Circle } from '@mui/icons-material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { useTheme } from '@mui/material/styles';
import StyledCardContent from './CardContent.styled';
import ExpandMore from '../shared/ExpandMore.styled';
import { calculateSlideCardColor } from '../../../util/offerColorCalculator';

const EirOfferCardFooter = ({ title, moreInfo, style, loading, slideNumber }) => {
  const theme = useTheme();
  // const lg = useMediaQuery(theme.breakpoints.up('md'));
  const [expanded, setExpanded] = useState(false);
  const handleExpandClick = () => {
    setExpanded(!expanded);
  };

  return !loading ? (
    moreInfo && moreInfo?.length > 0 && (
      <StyledCardContent
        sx={{
          ...style?.moreInfo,
          p: '4px 0 4px 0',
          backgroundColor: theme.palette.secondary.mobileActiveToggleBackground,
        }}
      >
        <Grid container alignItems='center' justifyContent='space-between'>
          <Grid item xs={6} />
          <Grid item xs={6} sx={{ display: 'flex', justifyContent: 'flex-end', pr: '1.6rem' }}>
            <Typography
              component='p'
              variant='body1'
              sx={{ color: theme.palette.primary.contrastText, pt: '4px' }}
              // className='swiper-no-swiping'
            >
              More info
            </Typography>
            <ExpandMore
              expand={expanded}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label={`More info on ${title} pricing`}
            >
              <ExpandMoreIcon
                sx={{ fontSize: '1.2rem', color: theme.palette.primary.contrastText }}
              />
            </ExpandMore>
          </Grid>
        </Grid>
        <Collapse in={expanded} timeout='auto' unmountOnExit sx={{}}>
          <CardContent
            sx={{
              ...style?.collapse,
              backgroundColor: calculateSlideCardColor({ slideNumber, theme }),
            }}
          >
            {moreInfo?.length > 0 && (
              <List
                sx={({ ...style?.descriptionList }, { listStyle: 'disc', paddingLeft: '1rem' })}
                dense
              >
                {moreInfo.map((list, i) => (
                  <ListItem key={i} sx={{ p: 0, display: 'list-item', listStyleType: 'none' }}>
                    <Stack
                      direction='row'
                      alignItems='center'
                      // justifyContent='flex-start'
                      sx={{ width: '100%', display: 'inline-flex', alignItems: 'baseline' }}
                    >
                      {list.icon?.src && (
                        <Box
                          className='item-icon'
                          component='img'
                          src={list.icon.src}
                          alt={list.icon?.alt}
                          sx={{ height: 25, width: 25 }}
                        />
                      )}
                      <Typography
                        variant='body1'
                        sx={{ color: theme.palette.primary.contrastText, paddingLeft: '0.2rem' }}
                        className='swiper-no-swiping'
                      >
                        {/* {list?.value} */}
                        <span dangerouslySetInnerHTML={{ __html: list?.value }} />
                      </Typography>
                    </Stack>
                  </ListItem>
                ))}
              </List>
            )}
            {/* <Typography variant='body2' sx={{ color: 'white' }}>
              {moreInfo}
            </Typography> */}
          </CardContent>
        </Collapse>
      </StyledCardContent>
    )
  ) : (
    <Skeleton sx={{ width: { xs: '100%', md: '100%' } }} height={32} variant='rectangular' />
  );
};

export default EirOfferCardFooter;
